import React from 'react';

import PropTypes from 'prop-types';

import Typography from '../WDS/Typography/Typography';

import styles from './Statistic.scss';

function Statistic(props) {
    const {
        className,
        subtitle,
        title,
        units,
        value,
    } = props;

    return (
        <div className={`${styles.statistic} ${className}`}>
            <Typography
                className={styles.statisticTitle}
                component="h3"
                variant="subtitle"
            >
                {title}
            </Typography>
            <span className={styles.statisticValueContainer}>
                <Typography
                    className={styles.statisticValue}
                    component="span"
                    variant="h2"
                >
                    {value}
                </Typography>
                {!!units && (
                    <Typography variant="h6">
                        {units}
                    </Typography>
                )}
            </span>
            {!!subtitle && (
                <Typography
                    className={styles.statisticSubtitle}
                    component="h3"
                    variant="subtitle"
                >
                    {subtitle}
                </Typography>
            )}
        </div>
    );
}

Statistic.propTypes = {
    className: PropTypes.string,
    subtitle: PropTypes.string,
    title: PropTypes.string,
    units: PropTypes.string,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
};

Statistic.defaultProps = {
    className: '',
    subtitle: '',
    title: '',
    units: '',
};

export default Statistic;
